import { Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { Pattern } from '../../../constant/Pattern';
import { Router } from '@angular/router';

@Component({
    selector: 'app-form-error-message',
    templateUrl: './form-error-message.component.html',
})
export class FormErrorMessageComponent {
    @Input() errors!: ValidationErrors | null;
    @Input() imgSize!: number;
    @Input() patternValidation = false;
    @Input() errorMessage!: string;
    @Input() uniqueFieldCustomMessage!: string | undefined;

    constructor(private router: Router) {}

    ngOnChanges() {
        this.validateErrors();
    }

    validateErrors() {
        this.errorMessage = '';
        if (this.errors?.['required']) {
            this.errorMessage = this.errorMessage ? this.errorMessage : 'This field is required and cannot be left blank.';
        }
        if (this.errors?.['minlength']) {
            this.errorMessage = this.errorMessage
                ? this.errorMessage
                : 'Please enter at least ' + this.errors?.['minlength'].requiredLength + ' characters.';
        }
        if (this.errors?.['maxlength']) {
            this.errorMessage = this.errorMessage
                ? this.errorMessage
                : 'You have reached maximum limit of ' + this.errors?.['maxlength'].requiredLength + ' allowed characters.';
        }
        if (this.errors?.['confirmPasswordValidator']) {
            this.errorMessage = this.errorMessage ? this.errorMessage : 'Password do not match. Please re-type your password.';
        }
        if (this.errors?.['validatePhoneNumber']) {
            this.errorMessage = this.errorMessage ? this.errorMessage : 'Please enter valid phone number.';
        }
        if (this.errors?.['imageSizeValidation']) {
            this.errorMessage = this.errorMessage ? this.errorMessage : 'File size is more than ' + this.imgSize + 'kb';
        }
        if (this.errors?.['uniqueFieldExist']) {
            this.errorMessage = this.uniqueFieldCustomMessage
                ? this.uniqueFieldCustomMessage
                : 'Email already exists, please use a different email address.';
        }
        if (this.errors?.['pattern']) {
            switch (this.errors?.['pattern'].requiredPattern) {
                case String(Pattern.email.pattern):
                    this.errorMessage = Pattern.email.message;
                    break;
                case String(Pattern.mobile.pattern):
                    this.errorMessage = Pattern.mobile.message;
                    break;
                case String(Pattern.alphaNumeric.pattern):
                    this.errorMessage = Pattern.alphaNumeric.message;
                    break;
                case String(Pattern.alphaWithSpace.pattern):
                    this.errorMessage = Pattern.alphaWithSpace.message;
                    break;
                case String(Pattern.alphaWithSpaceDot.pattern):
                    this.errorMessage = Pattern.alphaWithSpaceDot.message;
                    break;
                case String(Pattern.onlyAlpha.pattern):
                    this.errorMessage = Pattern.onlyAlpha.message;
                    break;
                case String(Pattern.onlyNumeric.pattern):
                    this.errorMessage = Pattern.onlyNumeric.message;
                    break;
                case String(Pattern.Password_Pattern.pattern):
                    this.errorMessage = Pattern.Password_Pattern.message;
                    break;
            }
        }
    }
}
